import { render, staticRenderFns } from "./EditLinkCopyButton.vue?vue&type=template&id=5c6be90c&scoped=true&"
import script from "./EditLinkCopyButton.vue?vue&type=script&lang=js&"
export * from "./EditLinkCopyButton.vue?vue&type=script&lang=js&"
import style0 from "./EditLinkCopyButton.vue?vue&type=style&index=0&id=5c6be90c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6be90c",
  null
  
)

export default component.exports